import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "rounded-full border border-red-400 bg-gray-50 p-1 shadow hover:border-blue-400 hover:bg-blue-50",
    onClick: $setup.openComponentSelector
  }, [
    _createVNode($setup["PlusIcon"], { class: "h-5 w-5" })
  ]))
}